import Vue from 'vue'
import router from './router/index'
import store from './vuex/store'
import filters from './filters/index'
import directives from './directives/index'
import interceptor from './router/interceptor'
import './registerServiceWorker'
import './quasar'
import './filters/capitalize'
import http from 'vue-resource'
import moment from 'moment'
import VueTheMask from 'vue-the-mask'
import vuelidate from 'vuelidate'
import Croppa from 'vue-croppa'
import 'vue-croppa/dist/vue-croppa.css'
import SocketService from './services/SocketService'
import VueDebounce from 'vue-debounce'

moment.locale('pt-BR')

Vue.use(http)
Vue.use(VueTheMask)
Vue.use(vuelidate)
Vue.use(Croppa)
Vue.use(SocketService)
Vue.use(VueDebounce, {
  defaultTime: '700ms',
  lock: true
})
Vue.http.interceptors.push(interceptor)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  filters,
  directives,
  template: '<App/>',
  components: {
    App: () => import(/* webpackChunkName: "meuGestor" */ './App.vue')
  }
})
